import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';

export default function Layout() {
  return (
    <div className="h-full flex flex-col">
      <Header />
      <div className="w-full px-8 py-5 flex flex-col">
        <Outlet />
      </div>
    </div>
  );
}
